import { createSelector } from '@reduxjs/toolkit';
import { selectContainWords } from 'shared/selectors/jsonQuery';

export const selectContainWordsFilter = createSelector(selectContainWords, value => ({
  label: 'Содержит слова в объявлении',
  value,
  placeholder: 'Например: срочно',
}));
